module.exports = __webpack_public_path__ + "img/ch.097b4d1b.svg";